/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './backup.tpl.html';

angular
  .module('chatter.backup', [])
  /**
   * Controller for the chatter.backup template.
   */
  .controller(
    'ChatterBackupCtrl',
    function (
      $scope,
      httpBatch,
      $filter,
      batchUtils,
      progressFactory,
      backupBatch,
      CHATTER_SIZES,
      BACKUP_STATE,
      TYPES,
      dashboardPrefs
    ) {
      var origBackupState = backupBatch.state;
      $scope.backupBatch = backupBatch;

      $scope.dashboardPrefs = dashboardPrefs;
      $scope.TYPES = TYPES;

      $scope.batchUtils = batchUtils;
      $scope.BACKUP_STATE = BACKUP_STATE;

      if (origBackupState === BACKUP_STATE.FINISHED) {
        progressFactory.disableProgress();
      }

      /**
       * Returns the shortened version of the number if it is >=1000 for the type and object.
       *
       * @param {string} type - The object type.
       * @param {string} recordType - The record type.
       *
       * @return {string} The number or shortened version of the number
       */
      $scope.getTypeCount = function (type, recordType) {
        var objectType =
            $scope.backupBatch && $scope.backupBatch.typeCounts ? $scope.backupBatch.typeCounts[type] : null,
          record = objectType ? objectType[recordType] : 0,
          num = record || 0;
        return $filter('shortNum')(num);
      };

      /**
       * Function used to generate the errors and warnings message.
       *
       * @returns {String} The string to display showing errors and warnings.
       */
      $scope.getWarnMessage = function () {
        var msg = '',
          verb,
          warnCnt,
          errCnt;

        if ($scope.backupBatch) {
          verb = $scope.backupBatch.warnings === 1 ? $filter('i18n')('IS') : $filter('i18n')('ARE');
          warnCnt = $filter('pluralize')($scope.backupBatch.warnings, 'SINGLE_WARNING', 'NUM_WARNINGS');
          errCnt = $filter('pluralize')($scope.backupBatch.errors, 'SINGLE_ERROR', 'NUM_ERRORS');
          msg = $filter('i18n')('WARNING_MSG_SIMPLE', [verb, warnCnt, errCnt]);
        }

        return msg;
      };

      // Watches to resize the canvas app based on the current state of the backup.
      $scope.$watch('backupInProgress ', function () {
        if (!$scope.backupInProgress || backupBatch.state === BACKUP_STATE.FINISHED) {
          // if the original backupStatus was not Finished then load the batch.
          if (origBackupState !== BACKUP_STATE.FINISHED) {
            httpBatch.getBatch($scope.stateParams.batchId).then(function (batch) {
              $scope.backupBatch = batch;
            });
          }

          if (!progressFactory.disabled) {
            progressFactory.disableProgress();
          }
        }
      });

      $scope.showBatchInApp = function () {
        // Use the chatter gotoApp function.
        $scope.gotoApp('?batchId=' + $scope.stateParams.batchId + '&page=batch');
      };
    }
  );
